import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <Link to="/" className="flex items-center gap-2 mb-8 cursor-pointer">
        <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50 text-lg">
          <i className="ri-play-circle-fill"></i>
        </span>
        <span className="text-lg font-black tracking-tight text-foreground-950">
          豆花<span className="text-primary-500">视频</span>
        </span>
      </Link>

      <p className="text-6xl md:text-8xl font-black text-primary-500 leading-none">404</p>
      <h1 className="mt-6 text-xl md:text-2xl font-bold text-foreground-950">
        抱歉，你访问的页面不存在
      </h1>
      <p className="mt-2 text-sm text-foreground-400 font-mono break-all">{location.pathname}</p>
      <p className="mt-4 text-sm text-foreground-500">
        页面可能已被移除或链接有误，去首页发现更多精彩影视内容吧。
      </p>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 px-6 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="flex items-center gap-2 px-6 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-search-line"></i>
          搜索影视
        </Link>
      </div>
    </div>
  );
}